if (!window.loyaltyPointsTooltipInitialized) {
  window.loyaltyPointsTooltipInitialized = true;

  // Create a single instance of the observer
  window.tooltipObserver = window.tooltipObserver || null;

  function attachTooltipListeners() {
    document.querySelectorAll('.loyalty-points-container .info').forEach(function(info) {
      // Skip if already has listeners
      if (info.hasAttribute('data-tooltip-initialized')) {
        return;
      }

      var tip = info.querySelector('.tip');
      if (!tip) {
        return;
      }

      let hideTimeout;

      function showTip() {
        clearTimeout(hideTimeout);
        tip.style.display = 'block';
      }

      function hideTip() {
        hideTimeout = setTimeout(() => {
          tip.style.display = 'none';
        }, 200);
      }

      info.addEventListener('mouseenter', showTip);
      info.addEventListener('focus', showTip);
      info.addEventListener('mouseleave', hideTip);
      info.addEventListener('blur', hideTip);

      tip.addEventListener('mouseenter', showTip);
      tip.addEventListener('mouseleave', hideTip);

      // Mark as initialized
      info.setAttribute('data-tooltip-initialized', 'true');
    });
  }

  // Initialize observer only once
  if (!window.tooltipObserver) {
    window.tooltipObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          attachTooltipListeners();
        }
      });
    });

    // Start observing the document body for changes
    window.tooltipObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initial attempt to attach listeners
  document.addEventListener('DOMContentLoaded', function() {
    attachTooltipListeners();
  });
}
